﻿'use strict';

angular.module('ntmApp').factory('RecurrenceModalsBridge', ['SetupService', 'Utils', 'Constants', 'FlashService', 'ListGridStatus',
    function (SetupService, Utils, Constants, FlashService, ListGridStatus) {

        function RecurrenceModalsBridge() {

            var self = this;

            self.openRecurrenceDialog = function (entity, model, selectedRow, callback) {

                var loading = FlashService.Loading();

                SetupService.GetRecurrenceData(getRequest(entity)).then(function (result) {

                    loading.dismiss();

                    if (result.data) {

                        result.data.isSharedRecurrence = !Utils.IsNull(entity.PK_RECSHR);
                        result.data.showSharedTab = entity.PK_RSRMACT;
						result.data.showWarningMessage = result.data.sharedPatternItems.length === 0;
						showRecurrenceModal(result.data, entity, model, selectedRow, callback);
                    }
                });
            };
        }

        function showRecurrenceModal(data, entity, model, selectedRow, callback) {
            var modal = Utils.OpenModal('', 'ng1/src/setup/templates/recurrenceView.html', 'RecurrenceController', data, 'recurrence-dialog', null, false);
            modal.result.then(function (result) {

                if (result) {
                    ListGridStatus.columns.forEach(function (column) {
                        if (!Utils.IsNull(result[column.fieldName])) {
                            selectedRow[column.name] = result[column.fieldName];

                            if (model) {
                                model[column.fieldName] = result[column.fieldName];
                            }
                        }
                    });
                    if (callback) {
                        callback();
                    }
                }
            });
        }

        function getRequest(entity) {

            return {
                dialogId: entity.PK_RSRMACT || entity.PK_RSSFACT || entity.PK_RSGLACT || entity.PK_TMPLACT || entity.PK_RECSHR,
                dialogName: entity.ACT_DSC || entity.NM_RECSHR + ' (Shared Recurrence)',
                setupType: Constants.Recurrence.RecurrenceActivitySetup.getValueByTableName(getTableName(entity)),
                recurrenceId: entity.PK_RECURR
            };
        }

        function getTableName(entity) {

            if (entity.PK_RECSHR) {
                return 'RECSHR';
            }

            if (entity.PK_RSSFACT) {
                return 'RSSFACT';
            }

            if (entity.PK_RSGLACT) {
                return 'RSGLACT';
            }

            if (entity.PK_TMPLACT) {
                return 'RSTMPLAC';
            }

            if (entity.PK_RSRMACT) {
                return 'RSRMACT';
            }


            return '';
        }

        return (RecurrenceModalsBridge);
    }
]);